export const engagementAppGroupIdCampaignCampaignIdMessageMessageVariationIdLatestTestResults =
  "/engagement/:app_group_id/campaign/:campaign_id/message/:message_variation_id/latest_test_results";
